export default __webpack_public_path__ + "static/media/mysql.0697e026.svg";